import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../components/LoadingError/Loading';
import Toast from '../components/LoadingError/Toast';
import { useAuth } from '../hooks/useAuth';

const Login = ({ user }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const { login } = useAuth();
  // const { login, loginGoogle } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user]);

  useEffect(() => {
    if (error) {
      setLoading(false);
    }
  }, [error]);

  const submitHandler = (e) => {
    e.preventDefault();
    const credentials = {
      email: email,
      password: password,
    };
    setLoading(true);
    login(credentials)
      .then((user) => {
        setLoading(false);
        navigate('/');
      })
      .catch((error) => {
        setError(error.response.data.message);
      });
  };

  return (
    <>
      <Toast />
      <div 
        className='d-flex justify-content-center align-items-start'
        style={{ minHeight: '100vh', paddingTop: '100px', paddingBottom: '50px', flex: 1 }}
      >
        <div
          className='card shadow'
          style={{ maxWidth: '380px', width: '100%' }}
        >
          <div className='card-body'>
          <h4 className='card-title mb-4 text-center'>Acceso</h4>

          <form onSubmit={submitHandler}>
            {loading ? (
              <div className='my-5'>
                <Loading />
              </div>
            ) : (
              <>
                <div className='mb-3'>
                  <input
                    className={`form-control ${error ? 'is-invalid' : ''}`}
                    placeholder='Email'
                    type='email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className='mb-3'>
                  <input
                    className={`form-control ${error ? 'is-invalid' : ''}`}
                    placeholder='Password'
                    type='password'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                {error && (
                  <div className='alert alert-danger py-2 mb-3' role='alert'>
                    <div className='d-flex align-items-start'>
                      <i className='fas fa-exclamation-triangle me-2 mt-1' style={{ fontSize: '0.875rem' }}></i>
                      <small className='flex-grow-1'>
                        Email o contraseña incorrectos. <br/>Por favor, inténtalo de nuevo.
                      </small>
                    </div>
                  </div>
                )}
              </>
            )}

            <div className='mb-4'>
              <button 
                type='submit' 
                className='btn btn-primary w-100'
                disabled={!email.trim() || !password.trim()}
                style={{
                  backgroundColor: (!email.trim() || !password.trim()) ? 'grey' : undefined
                }}
              >
                Acceder
              </button>
            </div>
          </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
